// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const slowpoke: PokeData = {
  "id": 79,
  "name": "slowpoke",
  "height": 12,
  "weight": 360,
  "base_experience": 63,
  "types": [
    PokeType.WATER,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "growl",
    "disable",
    "water-gun",
    "surf",
    "confusion",
    "psychic",
    "amnesia",
    "rest",
    "curse",
    "rain-dance",
    "psych-up",
    "yawn",
    "slack-off",
    "water-pulse",
    "zen-headbutt",
    "heal-pulse"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "growl",
    "psychic",
    "curse",
    "rain-dance",
    "zen-headbutt",
    "hydro-pump",
    "synchronize",
    "bubble",
    "reflect",
    "psychic-fangs",
    "water-spout"
  ],
  "evolution_chain": {
    "id": 33,
    "item": null,
    "species": [
      {
        "name": "slowpoke",
        "order": 85,
        "types": [
          PokeType.WATER,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "slowbro",
        "order": 86,
        "types": [
          PokeType.WATER,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 79,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 37,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "galarica-cuff"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      },
      {
        "name": "slowking",
        "order": 87,
        "types": [
          PokeType.WATER,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 79,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "galarica-wreath"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 71.25,
    "speed": 15,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
